import { __assign, __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { Link as ReactRouterLink } from 'react-router-dom';
import { Tooltip } from '../../primitives';
import { EllipsisText } from '../../composites';
export var isHtmlLinkProps = function (props) {
    return !!props.href;
};
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.generateClassNames = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return namespacedClassnames('link', _this.props.className, args);
        };
        return _this;
    }
    Link.prototype.render = function () {
        var props = this.props;
        var disabledCn = this.generateClassNames('disabled');
        var align = props.tooltipAlign;
        if (isHtmlLinkProps(props)) {
            var htmlClasses = this.generateClassNames('html', props.size || '', props.ellipsis ? 'ellipsis' : '');
            var maybeTarget = props.target ? { target: props.target } : { target: '_blank' };
            var maybeArrow = !props.hideArrow ? React.createElement("span", { className: 'arrow-icon' }) : null;
            var linkContent = (React.createElement(React.Fragment, null,
                props.children,
                maybeArrow));
            var linkContentEllipsis = (React.createElement(EllipsisText, { direction: 'top', tooltipText: typeof (props.children) === 'string' ? props.children : undefined, tooltipRelativeToBody: true, className: 'ellipsis-link' },
                React.createElement("span", null, props.children),
                maybeArrow));
            return !props.disabled ? (React.createElement("a", __assign({ className: htmlClasses, href: props.href, onClick: props.onClick }, maybeTarget), props.ellipsis ? linkContentEllipsis : linkContent)) : (React.createElement(Tooltip, { body: props.disabled, align: align, className: 'disabled-tooltip', relativeToBody: true },
                React.createElement("span", { className: disabledCn }, linkContent)));
        }
        else {
            var rrClasses = this.generateClassNames('rr', props.size || '');
            var maybeTarget = props.target ? { target: props.target } : {};
            var linkContent = (React.createElement(React.Fragment, null,
                props.children,
                props.forceArrow && React.createElement("span", { className: 'arrow-icon' })));
            return !props.disabled ?
                React.createElement(ReactRouterLink, __assign({ className: rrClasses, to: props.to, onClick: props.onClick }, maybeTarget), linkContent) :
                (React.createElement(Tooltip, { body: props.disabled, className: 'disabled-tooltip', align: align, relativeToBody: true },
                    React.createElement("span", { className: disabledCn }, linkContent)));
        }
    };
    return Link;
}(React.PureComponent));
export { Link };
//# sourceMappingURL=link.comp.js.map